import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseHttpService } from '../http/base.http.service';
import { ApiRouterService } from '../http/api.router';

@Injectable({
  providedIn: 'root',
})
export class ClientHttpService extends BaseHttpService {
  private baseURL = `clients`;
  private superAdminBaseURL = `superadmin/clients`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  public getServiceInfos(clientId: number) {
    let path = this.routerService.mount(`${this.baseURL}/${clientId}/services`);
    return this.read(path);
  }

  public getPaymentConfig(clientId: number) {
    const path = this.routerService.mount(`${this.baseURL}/${clientId}/payment-config`);
    return this.read(path);
  }

  public updatePaymentConfig(clientId: number, body: unknown) {
    const path = this.routerService.mount(`${this.baseURL}/${clientId}/payment-config`);
    return this.update(body, path);
  }

  public searchClients(queryParams: Record<string, string>) {
    return this.list(this.routerService.mount(this.superAdminBaseURL), queryParams);
  }

  public getClient(clientId: number) {
    return this.read(this.routerService.mount(`${this.superAdminBaseURL}/${clientId}`));
  }

  public createClient(body: unknown) {
    return this.create(body, this.routerService.mount(this.superAdminBaseURL));
  }

  public updateClient(clientId: number, body: unknown) {
    return this.update(body, this.routerService.mount(`${this.superAdminBaseURL}/${clientId}`));
  }

  public deactivateClient(clientId: number) {
    return this.delete(this.routerService.mount(`${this.superAdminBaseURL}/${clientId}`));
  }

  public reactivateClient(clientId: number) {
    return this.update({}, this.routerService.mount(`${this.superAdminBaseURL}/${clientId}/reactivate`));
  }

  public getClientConfig(clientId: number) {
    return this.read(this.routerService.mount(`${this.superAdminBaseURL}/${clientId}/config`));
  }

  public updateClientConfig(clientId: number, body: unknown) {
    return this.update(body, this.routerService.mount(`${this.superAdminBaseURL}/${clientId}/config`));
  }

  public saveClientInfo(clientId: number, body: unknown) {
    return this.update(body, this.routerService.mount(`${this.superAdminBaseURL}/${clientId}/info`));
  }

  public getClientInfoGroups(clientId: number) {
    return this.read(this.routerService.mount(`${this.superAdminBaseURL}/${clientId}/infos`));
  }

  public createClientInfoGroup(clientId: number, body: unknown) {
    return this.create(body, this.routerService.mount(`${this.superAdminBaseURL}/${clientId}/infos`));
  }

  public updateClientInfoGroup(clientId: number, clientInfoId: number, body: unknown) {
    const path = this.routerService.mount(`${this.superAdminBaseURL}/${clientId}/infos/${clientInfoId}`);
    return this.update(body, path);
  }

  public deleteClientInfoGroup(clientId: number, clientInfoId: number) {
    return this.delete(this.routerService.mount(`${this.superAdminBaseURL}/${clientId}/infos/${clientInfoId}`));
  }

  public searchClientTowns(clientId: number, queryParams: Record<string, string>) {
    return this.list(this.routerService.mount(`${this.superAdminBaseURL}/${clientId}/towns`), queryParams);
  }
}
